module.exports = __webpack_public_path__ + "static/media/a12.4970f2ee.pdf";